const crudable = require('../constants/crudable');
const helpers = require('../util/reduxHelpers');

const REPORT_CRUD_ACTION_TYPES = helpers.generateActions(crudable.CRUDABLE_REPORT_RESOURCES);

export default {
  ...REPORT_CRUD_ACTION_TYPES,
  LOGIN_EXPIRED: 'LOGIN_EXPIRED',
  GET_USER_TEAM_SUCCESS: 'GET_USER_TEAM_SUCCESS',
  GET_USER_TEAM_ERROR: 'GET_USER_TEAM_ERROR',
  GET_ACCOUNT_USERS_SUCCESS: 'GET_ACCOUNT_USERS_SUCCESS',
  GET_ACCOUNT_USERS_ERROR: 'GET_ACCOUNT_USERS_ERROR',
  GET_ACCOUNT_SUMMARIES_SUCCESS: 'GET_ACCOUNT_SUMMARIES_SUCCESS',
  GET_ACCOUNT_SUMMARIES_ERROR: 'GET_ACCOUNT_SUMMARIES_ERROR',
  GET_LICENSED_PRODUCT_SUCCESS: 'GET_LICENSED_PRODUCT_SUCCESS',
  GET_LICENSED_PRODUCT_ERROR: 'GET_LICENSED_PRODUCT_ERROR',
  GET_FASTSCOUT_ROLES_SUCCESS: 'GET_FASTSCOUT_ROLES_SUCCESS',
  GET_FASTRECRUIT_ROLES_SUCCESS: 'GET_FASTRECRUIT_ROLES_SUCCESS',
  GET_FASTACCESS_ROLES_SUCCESS: 'GET_FASTACCESS_ROLES_SUCCESS',
  GET_FASTSCOUT_ROLES_ERROR: 'GET_FASTSCOUT_ROLES_ERROR',
  GET_FASTRECRUIT_ROLES_ERROR: 'GET_FASTRECRUIT_ROLES_ERROR',
  GET_FASTACCESS_ROLES_ERROR: 'GET_FASTACCESS_ROLES_ERROR',
  ACCOUNT_BUILDER_VALID_ORIGIN: 'ACCOUNT_BUILDER_VALID_ORIGIN',
  CLEAR_ACCOUNT_BUILDER_ORIGIN: 'CLEAR_ACCOUNT_BUILDER_ORIGIN',
  CREATE_ACCOUNT_USER: 'CREATE_ACCOUNT_USER',
  CREATE_ACCOUNT_USER_SUCCESS: 'CREATE_ACCOUNT_USER_SUCCESS',
  CREATE_ACCOUNT_USER_ERROR: 'CREATE_ACCOUNT_USER_ERROR',
};